module.exports = __webpack_public_path__ + "media/stashboard/download-on-the-app-store-72b01ac7.png";